import React, { FC } from 'react'
import { styled, css } from '@creditas/stylitas'

import { MainWrapper } from 'components/MainWrapper'
import { ToastrContainer } from 'components/Toastr'

import { Calendar } from './Calendar'
import { Content } from './Content'

const GridContainer = styled.div<{ calendarIsVisible?: boolean }>`
  display: grid;
  min-height: calc(100vh - 104px);

  ${props =>
    props.calendarIsVisible
      ? css`
          grid-template-columns: 336px auto;
        `
      : css`
          grid-template-columns: auto;
          margin-left: auto;
          margin-right: auto;
          width: 1170px;
        `}
`

const Assignments: FC<{ calendarIsVisible?: boolean }> = ({
  calendarIsVisible = false,
}) => (
  <MainWrapper useNewNavbar>
    <GridContainer calendarIsVisible={calendarIsVisible}>
      <Calendar calendarIsVisible={calendarIsVisible} />
      <Content />
      <ToastrContainer />
    </GridContainer>
  </MainWrapper>
)

export { Assignments }
